export default __webpack_public_path__ + "static/N0179-9ecd83a4fe669fb9493d2078d032a52d.png";